import { useState, useEffect, useCallback } from 'react';
import { AdminSidebar } from './AdminDashboard';
import api from '../lib/api';
import { User, ShieldCheck, ShieldSlash } from '@phosphor-icons/react';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ✅ Fonction stabilisée
  const fetchUsers = useCallback(() => {
    api.get(`/admin/users?page=${page}&limit=20`)
      .then(r => {
        setUsers(r.data.users);
        setTotalPages(r.data.pages);
      })
      .catch(() => {});
  }, [page]); // ← dépendance réelle

  // ✅ Plus d'avertissement ESLint
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const toggleUser = async (id) => {
    try {
      await api.put(`/admin/users/${id}/toggle`);
      fetchUsers(); // fonctionne toujours
    } catch {}
  };

  return (
    <div className="pt-20 min-h-screen" data-testid="admin-users-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <AdminSidebar />
          <div className="flex-1">
            <h1 className="font-heading text-3xl text-white mb-8">Utilisateurs</h1>
            <div className="space-y-3">
              {users.map(u => (
                <div key={u.id} className="bg-desti-surface border border-white/5 p-4 flex items-center justify-between" data-testid={`admin-user-${u.id}`}>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-desti-gold/10 flex items-center justify-center">
                      <User size={18} className="text-desti-gold" />
                    </div>
                    <div>
                      <p className="text-sm text-white">{u.firstName} {u.lastName}</p>
                      <p className="text-xs text-desti-text">{u.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className={`text-xs px-2 py-1 ${u.role === 'ADMIN' ? 'bg-desti-gold/20 text-desti-gold' : 'bg-white/5 text-white/50'}`}>
                      {u.role}
                    </span>
                    <span className={`text-xs ${u.isActive ? 'text-green-400' : 'text-red-400'}`}>
                      {u.isActive ? 'Actif' : 'Bloque'}
                    </span>
                    {u.role !== 'ADMIN' && (
                      <button
                        onClick={() => toggleUser(u.id)}
                        className="text-xs px-3 py-1 border border-white/10 text-white/50 hover:text-white hover:border-desti-gold transition-colors"
                        data-testid={`toggle-user-${u.id}`}
                      >
                        {u.isActive ? <ShieldSlash size={14} /> : <ShieldCheck size={14} />}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
